import type { PropsCoreState } from '~/store/interfaces';

export const selectUser = ({ user }: PropsCoreState) => user;
export const selectUserData = ({ user }: PropsCoreState) => user.data;
